import { render, staticRenderFns } from "./ExSale2.vue?vue&type=template&id=6ab7379b&scoped=true"
import script from "./ExSale2.vue?vue&type=script&lang=js"
export * from "./ExSale2.vue?vue&type=script&lang=js"
import style0 from "./ExSale2.vue?vue&type=style&index=0&id=6ab7379b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ab7379b",
  null
  
)

export default component.exports